<template>
    <main class="">
        <div class="">
            <h1 class="sr-only">:title="$t('r_legal.privacy_policy')"</h1>
            <!-- 2 columns  -->
            <div class="flex items-start flex-nowrap">
                <!-- Left column -->
                <DocumentContent
                    :title="$t('r_legal.privacy_policy') + footer.legal.www"
                    view="policy"
                    :footer="footer"
                    :sections="sections"
                    :embed="embed"
                    @updateIframeHeight="$emit('updateIframeHeight')"
                >
                </DocumentContent>
                <!-- Right column -->
                <DocumentList
                    :footer="footer"
                    :sections="sections"
                    @updateIframeHeight="$emit('updateIframeHeight')"
                />
            </div>
        </div>
    </main>
</template>

<script>
import DocumentContent from "../shared/DocumentContent.vue";
import DocumentList from "../shared/DocumentList.vue";

export default {
    name: "PolicyMain",
    emits: ["updateIframeHeight"],
    props: {
        footer: Object,
        sections: Array,
        embed: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        DocumentContent,
        DocumentList,
    },
};
</script>
